import {
  PreviewSnippet,
  SxProps,
  Tooltip,
  TooltipProps,
  notify,
  Typography,
  Stack,
} from '@cast/design-system';

type Props = Omit<TooltipProps, 'title'> & {
  title: string;
  error: string;
  highlightColor?: string;
  snippetSx?: SxProps;
};

export const ErrorTooltip = ({
  title,
  error,
  highlightColor,
  children,
  snippetSx,
  ...props
}: Props) => {
  return (
    <Tooltip
      title={
        <Stack gap={8}>
          <Typography variant="P12R" data-testid="error-title">
            {title}
          </Typography>

          <PreviewSnippet
            code={error}
            errorHighlight={highlightColor || true}
            onCopy={() =>
              notify.success('Copied to clipboard', {
                key: 'copied-to-clipboard',
              })
            }
            sx={snippetSx}
          />
        </Stack>
      }
      arrow
      testId="error-tooltip"
      {...props}
    >
      {children}
    </Tooltip>
  );
};
